import { createSignal } from '@verclam/pulsar';

export type BeneficiarySidebarContext = {
	readonly beneficiaryId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the dossier carried by `beneficiaryId`; a
 * `beneficiaryId` of `null` inside an open context creates one instead.
 */
const beneficiarySidebarSignal = createSignal<BeneficiarySidebarContext | null>(null);

export const openBeneficiarySidebar = (beneficiaryId: number | null = null): void => {
	beneficiarySidebarSignal.value = { beneficiaryId };
};

export const closeBeneficiarySidebar = (): void => {
	beneficiarySidebarSignal.value = null;
};

export default beneficiarySidebarSignal;
